var _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotSuitableForInfants = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 30 31"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M11.188 15.625c.195 0 .354.159.354.354M10.833 15.98c0-.196.159-.355.354-.355"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M11.187 16.333a.354.354 0 0 1-.354-.354M11.542 15.979a.354.354 0 0 1-.354.354M17.563 15.625c.195 0 .354.159.354.354M17.208 15.98c0-.196.159-.355.354-.355"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M17.562 16.333a.354.354 0 0 1-.354-.354M17.917 15.979a.354.354 0 0 1-.355.354"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M22.52 14.563h-.012a8.5 8.5 0 0 0-16.266 0H6.23a2.48 2.48 0 1 0 0 4.958h.013a8.5 8.5 0 0 0 16.266 0h.013a2.48 2.48 0 1 0 0-4.958",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M17.542 20.584a4.25 4.25 0 0 1-6.335 0M16.725 5a4.25 4.25 0 1 1-6.466 4.603"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  clipPath: "url(#notSuitableForInfants_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.935 16a14.062 14.062 0 1 0 28.125 0A14.062 14.062 0 0 0 .935 16M5.054 25.944 24.94 6.057"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "notSuitableForInfants_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 1h30v30H0z"
})))));
export default SvgNotSuitableForInfants;